import Gear from './src/gear-combined';
export default Gear;